var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Header',{attrs:{"bordered":false}}),_c('section',{staticClass:"profile columns"},[_c('Sidebar'),_c('div',{staticClass:"column"},[_vm._t("default",null,{"user":_vm.user})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }